import SyncAltIcon from '@mui/icons-material/SyncAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import LedgerIcon from '../../assets/Images/ledger1.png';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';

const DashboardIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.6733 9.47317C17.8557 9.10128 17.7021 8.65194 17.3302 8.46952C16.9583 8.2871 16.509 8.44069 16.3265 8.81257L14.8662 11.7896C14.4136 12.7124 13.0832 12.6673 12.6941 11.716C11.8149 9.56699 8.80947 9.46518 7.7869 11.5498L6.32657 14.5268C6.14415 14.8987 6.29774 15.3481 6.66962 15.5305C7.0415 15.7129 7.49085 15.5593 7.67327 15.1874L9.13361 12.2104C9.58624 11.2876 10.9166 11.3327 11.3057 12.284C12.1849 14.433 15.1903 14.5348 16.2129 12.4502L17.6733 9.47317Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4635 2.37373C15.3214 2.24999 13.8818 2.24999 12.0452 2.25H11.9548C10.1182 2.24999 8.67861 2.24999 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62024 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62024C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24999 8.67861 2.24999 10.1182 2.25 11.9548V12.0452C2.24999 13.8818 2.24999 15.3214 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62024 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.67859 21.75 10.1182 21.75 11.9547 21.75H12.0453C13.8818 21.75 15.3214 21.75 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.75 15.3214 21.75 13.8818 21.75 12.0453V11.9547C21.75 10.1182 21.75 8.67859 21.6263 7.53648C21.5 6.37094 21.2377 5.42656 20.6518 4.62024C20.2972 4.13209 19.8679 3.70281 19.3798 3.34815C18.5734 2.76232 17.6291 2.50001 16.4635 2.37373ZM5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69804 3.865C8.74999 3.75103 10.1084 3.75 12 3.75C13.8916 3.75 15.25 3.75103 16.302 3.865C17.3399 3.97745 17.9901 4.19259 18.4981 4.56168C18.8589 4.82382 19.1762 5.14111 19.4383 5.50191C19.8074 6.00992 20.0225 6.66013 20.135 7.69804C20.249 8.74999 20.25 10.1084 20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69804C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168Z" fill="white" />
    </svg>
)
const UsersIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9617 11.892H11.9927C14.8247 11.892 17.1287 9.58802 17.1287 6.75602C17.1287 3.92402 14.8247 1.61902 11.9927 1.61902C9.15975 1.61902 6.85575 3.92402 6.85575 6.75302C6.85075 8.12202 7.37975 9.41002 8.34375 10.381C9.30675 11.351 10.5917 11.888 11.9617 11.892ZM8.35575 6.75602C8.35575 4.75102 9.98775 3.11902 11.9927 3.11902C13.9977 3.11902 15.6287 4.75102 15.6287 6.75602C15.6287 8.76102 13.9977 10.392 11.9927 10.392H11.9647C10.9967 10.39 10.0897 10.01 9.40775 9.32302C8.72575 8.63702 8.35275 7.72602 8.35575 6.75602Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.40552 18.7559C4.40552 22.3809 10.1215 22.3809 11.9995 22.3809C13.8775 22.3809 19.5945 22.3809 19.5945 18.7339C19.5945 15.9409 16.1165 13.5809 11.9995 13.5809C7.88352 13.5809 4.40552 15.9509 4.40552 18.7559ZM5.90552 18.7559C5.90552 17.0209 8.51152 15.0809 11.9995 15.0809C15.4885 15.0809 18.0945 17.0099 18.0945 18.7339C18.0945 20.1579 16.0435 20.8809 11.9995 20.8809C7.95652 20.8809 5.90552 20.1659 5.90552 18.7559Z" fill="white" />
    </svg>
)

const SystemLedgerIcon = () => (
    <img src={LedgerIcon} alt="Ledger Icon" style={{ width: '24px', height: '24px' }} />
)

const TransferIcon = () => (
    <SyncAltIcon style={{ color: 'white' }} />
);

const plateFormBalanceIcon = () => (
    <AccountBalanceWalletIcon style={{ color: 'white' }} />
);

const TransactionIconComponent = () => (
    <ReceiptLongIcon style={{ color: 'white' }} />
);

const ReferralIcon = () => (
    <Diversity3OutlinedIcon style={{ color: 'white' }} />
);

const AuditLogsIcon = () => (
    <GavelOutlinedIcon style={{ color: 'white' }} />
);

const NotificationsIcon = () => (
    <NotificationsActiveOutlinedIcon style={{ color: 'white' }} />
);

const GroupsIcon = () => (
    <GroupsOutlinedIcon style={{ color: 'white' }} />
);

const CountriesIcon = () => (
    <PublicOutlinedIcon style={{ color: 'white' }} />
);

const SettingsIconComponent = () => (
    <SettingsOutlinedIcon style={{ color: 'white' }} />
);

export const menuOptions = [
    {
        id: 1,
        label: 'Dashboard',
        path: '/admin/dashboard',
        icon: DashboardIcon
    },
    {
        id: 2,
        label: 'Users',
        path: '/admin/users',
        icon: UsersIcon
    },
    {
        id: 3,
        label: 'Referrals',
        path: '/admin/referrals',
        icon: ReferralIcon
    },
    {
        id: 4,
        label: 'Transfers',
        path: '/admin/transfers',
        icon: TransferIcon
    },
    {
        id: 5,
        label: 'Platform Balance',
        path: '/admin/platform-balance',
        icon: plateFormBalanceIcon
    },
    {
        id: 6,
        label: 'Transactions',
        path: '/admin/transactions',
        icon: TransactionIconComponent
    },
    {
        id: 7,
        label: 'System Ledger',
        path: '/admin/system-ledger',
        icon: SystemLedgerIcon
    },
    {
        id: 8,
        label: 'Settings',
        path: '/admin/settings',
        icon: SettingsIconComponent
    },
    {
        id: 9,
        label: 'Audit Logs',
        path: '/admin/audit-logs',
        icon: AuditLogsIcon
    },
    {
        id: 10,
        label: 'Notifications',
        path: '/admin/notifications',
        icon: NotificationsIcon
    },
    {
        id: 11,
        label: 'Groups',
        path: '/admin/groups',
        icon: GroupsIcon
    },
    {
        id: 12,
        label: 'Countries',
        path: '/admin/countries',
        icon: CountriesIcon
    },
];